// Frontend profanity filter - mirrors backend validation
// Keep this list in sync with server/utils/profanityFilter.js
const badWords = [
  'fuck', 'shit', 'bitch', 'ass', 'damn', 'hell', 'crap',
  'bastard', 'dick', 'pussy', 'cock', 'whore', 'slut',
  'fag', 'nigger', 'chink', 'retard', 'cunt', 'piss'
];

// Create regex patterns for each bad word with word boundaries
const badWordPatterns = badWords.map(word => ({
  word,
  regex: new RegExp(`\\b${word}\\b`, 'gi')
}));

/**
 * Check if text contains profanity
 * @param {string} text - Text to check
 * @returns {Object} - { hasProfanity: boolean, foundWords: array }
 */
export const containsProfanity = (text) => {
  if (!text || typeof text !== 'string') {
    return { hasProfanity: false, foundWords: [] };
  }

  const foundWords = [];

  for (const { word, regex } of badWordPatterns) {
    if (regex.test(text)) {
      foundWords.push(word);
    }
  }

  return {
    hasProfanity: foundWords.length > 0,
    foundWords
  };
};

/**
 * Validate text and return error message if profanity found
 * @param {string} text - Text to validate
 * @param {string} fieldName - Name of the field being validated
 * @returns {string|null} - Error message or null if valid
 */
export const validateNoProfanity = (text, fieldName = 'Text') => {
  const result = containsProfanity(text);
  
  if (result.hasProfanity) {
    return `${fieldName} contains inappropriate language. Please remove offensive words and try again.`;
  }
  
  return null;
};
